import { IconButton } from '@chakra-ui/react';
import { FiX } from 'react-icons/fi';

interface ClearFiltersButtonProps {
  onClearAllFilters?: () => void;
  hasActiveFilters?: boolean;
  isDisabled?: boolean;
  width?: string;
}

export const ClearFiltersButton = ({
  onClearAllFilters,
  hasActiveFilters,
  isDisabled,
  width
}: ClearFiltersButtonProps) => {
  if (!onClearAllFilters || !hasActiveFilters) {
    return null;
  }

  return (
    <IconButton
      size="md"
      variant="ghost"
      onClick={onClearAllFilters}
      isDisabled={isDisabled}
      icon={<FiX />}
      width={width}
      aria-label="Clear All Filters"
      title="Clear All Filters"
    />
  );
};
